let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cWJo9")).then(() => parcelRequire('e1fke'));